/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_vendor_gcp': {
    width: 22,
    height: 18,
    viewBox: '0 0 22 18',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-1-3h24v24H-1z"/><g fill-rule="nonzero"><path pid="1" d="M13.87 4.844h.667l1.9-1.9.093-.807A8.54 8.54 0 0 0 2.637 6.304c.212-.087.446-.1.666-.04l3.8-.627s.194-.32.294-.3a4.74 4.74 0 0 1 6.486-.493h-.013z" _fill="#EA4335"/><path pid="2" d="M19.143 6.304a8.56 8.56 0 0 0-2.58-4.16l-2.666 2.667a4.74 4.74 0 0 1 1.74 3.76v.473a2.373 2.373 0 1 1 0 4.747H10.89l-.473.48v2.846l.473.474h4.747a6.173 6.173 0 0 0 3.506-11.287z" _fill="#4285F4"/><path pid="3" d="M6.137 17.564h4.746v-3.8H6.137a2.36 2.36 0 0 1-.98-.213l-.667.206-1.913 1.9-.167.667a6.14 6.14 0 0 0 3.727 1.24z" _fill="#34A853"/><path pid="4" d="M6.137 5.237A6.173 6.173 0 0 0 2.41 16.304l2.753-2.753a2.373 2.373 0 1 1 3.14-3.14l2.754-2.754a6.167 6.167 0 0 0-4.92-2.42z" _fill="#FBBC05"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_vendor_gcp.js